export default {"src":"/_next/static/media/se_positionner.ddb54fb7.svg","height":699,"width":749};